import { WatchTriggerInterface } from '../../../types';
import { WatchTriggerActionType } from '../../../types/enum';

const excludeRules : { [trigger: string]: string[] } = {
  'quote_prop_42-102': ['quote_prop_51', 'quote_prop_52'],
};
const initialHiddenFields = [
  'frm_personal_address2', 'frm_personal_address1', 'quote_prop_47',
  'frm_personal_postcode', 'frm_personal_address4', 'frm_personal_address3',
  'company_reg_address_is_correspondence_address',
  'frm_personal_country_code', 'business_name', 'form-business_name_note_nohide',
  'form-le-explainer',
];

const watchTriggers: { [trigger: string]: WatchTriggerInterface[] } = {
  info_where: [{
    values: ['A marketing communication from Kingsbridge', 'Social network (Twitter, LinkedIn etc)'],
    on: {
      type: WatchTriggerActionType.ParseFields,
      target: [],
    },
    off: {
      type: WatchTriggerActionType.None,
      target: [],
    },
    index: 1,
  }],
  quote_prop_42: [{
    values: ['quote_prop_42-102'],
    on: {
      type: WatchTriggerActionType.Remove,
      target: ['quote_prop_51', 'quote_prop_52'],
    },
    off: {
      type: WatchTriggerActionType.None,
      target: [],
    },
    index: 0,
  }, {
    values: ['quote_prop_42-1007', 'quote_prop_42-99', 'quote_prop_42-96', 'quote_prop_42-1010',
      'quote_prop_42-105', 'quote_prop_42-102', 'quote_prop_42-1112', 'quote_prop_42-103',
      'quote_prop_42-98', 'quote_prop_42-97', 'quote_prop_42-100', 'quote_prop_42-104'],
    on: {
      type: WatchTriggerActionType.Remove,
      target: ['quote_prop_45'],
    },
    off: {
      type: WatchTriggerActionType.None,
      target: [],
    },
    index: 0,
  }],
  quote_prop_43: [{
    values: ['quote_prop_43-789', 'quote_prop_43-552', 'quote_prop_43-475', 'quote_prop_43-177', 'quote_prop_43-178'],
    trigger: {
      target: 'quote_prop_42',
      values: ['quote_prop_42-102'],
    },
    on: {
      type: WatchTriggerActionType.Show,
      target: ['quote_prop_51', 'quote_prop_52'],
    },
    off: {
      type: WatchTriggerActionType.Hide,
      target: ['quote_prop_51', 'quote_prop_52'],
    },
    index: 0,
  }],
  business_companyreg: [{
    values: ['all'],
    on: {
      attribute: {
        value: 'disabled',
        key: 'disabled',
      },
      type: WatchTriggerActionType.AddAttribute,
      target: ['business_name'],
    },
    off: {
      type: WatchTriggerActionType.None,
      target: [],
    },
    index: 0,
  }],
  business_type: [{
    values: ['Limited Company'],
    on: {
      attribute: {
        value: 'disabled',
        key: 'disabled',
      },
      type: WatchTriggerActionType.AddAttribute,
      target: ['business_name'],
    },
    off: {
      type: WatchTriggerActionType.None,
      target: [],
    },
    index: 0,
  }, {
    values: ['Limited Company'],
    on: {
      type: WatchTriggerActionType.Show,
      target: ['form-business_name_note_nohide', 'business_companyreg',
        'company_reg_address_is_correspondence_address', 'business_company_IoM_CI', 'business_name',
        'frm_personal_postcode', 'frm_personal_address1', 'frm_personal_address2',
        'frm_personal_address4', 'frm_personal_address3',
        'frm_personal_country_code'],
    },
    off: {
      type: WatchTriggerActionType.Hide,
      target: ['business_companyreg',
        'company_reg_address_is_correspondence_address', 'business_company_IoM_CI',
        'form-business_name_note_nohide'],
    },
    index: 1,
  }, {
    values: ['Sole Trader'],
    on: {
      type: WatchTriggerActionType.Show,
      target: ['business_name', 'frm_personal_postcode', 'frm_personal_address1', 'frm_personal_address2',
        'frm_personal_address4', 'frm_personal_address3',
        'frm_personal_country_code'],
    },
    off: {
      type: WatchTriggerActionType.None,
      target: [],
    },
    index: 1,
  }, {
    values: ['Limited Company'],
    on: {
      attribute: {
        value: 'disabled',
        key: 'disabled',
      },
      type: WatchTriggerActionType.AddAttribute,
      target: ['business_name'],
    },
    off: {
      type: WatchTriggerActionType.None,
      target: [],
    },
    index: 0,
  }, {
    values: ['Sole Trader'],
    on: {
      attribute: {
        value: '',
        key: 'disabled',
      },
      type: WatchTriggerActionType.RemoveAttribute,
      target: ['business_name', 'frm_personal_address1', 'frm_personal_address2',
        'frm_personal_postcode', 'frm_personal_address4', 'frm_personal_address3',
        'frm_personal_country_code'],
    },
    off: {
      type: WatchTriggerActionType.None,
      target: [],
    },
    index: 0,
  }],
  quote_prop_100: [
    {
      values: ['quote_prop_100-1369'],
      on: {
        type: WatchTriggerActionType.Show,
        target: ['form-le-explainer'],
      },
      off: {
        type: WatchTriggerActionType.Hide,
        target: ['form-le-explainer'],
      },
      index: 1,
    },
  ],
  company_reg_address_is_correspondence_address: [{
    values: [true],
    on: {
      type: WatchTriggerActionType.AddAttribute,
      attribute: {
        value: 'disabled',
        key: 'disabled',
      },
      target: [
        'frm_personal_address1', 'frm_personal_address2',
        'frm_personal_postcode', 'frm_personal_address4', 'frm_personal_address3',
        'frm_personal_country_code', 'business_name'],
    },
    off: {
      type: WatchTriggerActionType.RemoveAttribute,
      attribute: {
        value: '',
        key: 'disabled',
      },
      target: [
        'frm_personal_address1', 'frm_personal_address2',
        'frm_personal_postcode', 'frm_personal_address4', 'frm_personal_address3',
        'frm_personal_country_code'],
    },
    index: 0,
  }],
  promo_code: [
    {
      values: ['all'],
      on: {
        type: WatchTriggerActionType.Show,
        target: ['coupon_message'],
      },
      off: {
        type: WatchTriggerActionType.Hide,
        target: ['coupon_message'],
      },
      index: 0,
    },
  ],
  business_company_IoM_CI: [
    {
      values: [true],
      on: {
        type: WatchTriggerActionType.Hide,
        target: ['business_companyreg', 'company_reg_address_is_correspondence_address', 'form-business_name_note_nohide'],
      },
      off: {
        type: WatchTriggerActionType.Show,
        target: ['form-business_name_note_nohide', 'business_companyreg', 'company_reg_address_is_correspondence_address'],
      },
      index: 0,
    },
    {
      values: [true],
      on: {
        type: WatchTriggerActionType.None,
        target: [],
      },
      off: {
        attribute: {
          value: 'disabled',
          key: 'disabled',
        },
        type: WatchTriggerActionType.AddAttribute,
        target: ['business_name'],
      },
      index: 0,
    },
    {
      values: [true],
      on: {
        type: WatchTriggerActionType.RemoveAttribute,
        attribute: {
          value: '',
          key: 'disabled',
        },
        target: [
          'frm_personal_address1', 'frm_personal_address2',
          'frm_personal_postcode', 'frm_personal_address4', 'frm_personal_address3',
          'frm_personal_country_code', 'business_name'],
      },
      off: {
        type: WatchTriggerActionType.None,
        target: [],
      },
      index: 0,
    },
  ],
  payment_paytype: [{
    values: ['creditcard'],
    on: {
      type: WatchTriggerActionType.LoadFields,
      data: 'get_cc',
      target: [],
    },
    off: {
      type: WatchTriggerActionType.None,
      target: [],
    },
    index: 2,
  },
  {
    values: ['directdebit'],
    on: {
      type: WatchTriggerActionType.LoadFields,
      data: 'get_dd',
      target: ['direct_debit_terms'],
    },
    off: {
      type: WatchTriggerActionType.None,
      target: [],
    },
    index: 2,
  },
  ],
  payment_cardusebill: [{
    values: ['0'],
    on: {
      type: WatchTriggerActionType.Hide,
      target: ['payment_bill_postcode', 'payment_bill_address1', 'payment_bill_address4', 'payment_bill_address2', 'payment_bill_address3',
        'payment_bill_country'],
    },
    off: {
      type: WatchTriggerActionType.Show,
      target: ['payment_bill_postcode', 'payment_bill_address1', 'payment_bill_address4', 'payment_bill_address2', 'payment_bill_address3',
        'payment_bill_country'],
    },
    index: 1,
  }],
};
const addToTrigger = (trigger: string, watchTrigger: WatchTriggerInterface) => {
  watchTriggers[trigger] = watchTriggers[trigger] || [];
  const triggers = watchTriggers[trigger];
  let match: any = null;
  triggers.forEach((tr: WatchTriggerInterface) => {
    if ((watchTrigger.on.target.filter((element) => tr.on.target.includes(element)).length > 0
            && watchTrigger.on.type === tr.on.type)
            || (watchTrigger.on.target.length === 0 && tr.on.target.length === 0
              && watchTrigger.on.type !== WatchTriggerActionType.None)) {
      match = tr;
    }
  });
  if (match) {
    match.values = match.values?.concat(watchTrigger.values);
  } else {
    watchTriggers[trigger].push(watchTrigger);
  }
};

if (window.quickInfoData && window.quickInfoData.industryCtrl) {
  addToTrigger(window.quickInfoData.industryCtrl, {
    values: ['all'],
    on: {
      type: WatchTriggerActionType.UpdateTransaction,
      target: [],
    },
    off: {
      type: WatchTriggerActionType.None,
      target: [],
    },
    index: 0,
  });

  addToTrigger(window.quickInfoData.numberOfFeeEarnersCtrl, {
    values: ['quote_prop_76-1086', 'quote_prop_76-1087', 'quote_prop_76-1088', 'quote_prop_76-1089'],
    on: {
      type: WatchTriggerActionType.RemoveOption,
      target: [window.quickInfoData.industryCtrl],
      options: [{
        value: 'quote_prop_42-1112',
      },
      {
        value: 'quote_prop_42-98',
      },
      ],
    },
    off: {
      type: WatchTriggerActionType.AddOption,
      target: [window.quickInfoData.industryCtrl],
      options: [{
        text: 'Nuclear',
        value: 'quote_prop_42-98',
      }, {
        text: 'Media & Creative',
        value: 'quote_prop_42-1112',
      }],
    },
    index: 0,
  });
}

export default watchTriggers;

export {
  addToTrigger,
  excludeRules,
  initialHiddenFields,
};
